import React from 'react';
import { Paper, Typography } from '@mui/material';

const Privacy: React.FC = () => {
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>Privacy Policy</Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Last updated: 2025-10-17
      </Typography>
      <Typography variant="body1" paragraph>
        We respect your privacy. This site primarily uses publicly available legislative data. When you create an account or use personalized features, we may store information necessary to provide those services (for example, saved searches or bookmarks).
      </Typography>
      <Typography variant="body1" paragraph>
        We use cookies and local storage to keep you signed in, remember preferences, and measure anonymous usage. We may use third-party analytics and advertising services (such as Google AdSense) that set their own cookies. You can manage cookies via your browser settings.
      </Typography>
      <Typography variant="body1" paragraph>
        We do not sell your personal information. We may disclose limited data to service providers solely to operate the application (e.g., hosting, caching, content delivery) and only under appropriate safeguards.
      </Typography>
      <Typography variant="body1" paragraph>
        If you have questions or requests related to your data, please contact us via the Contact page.
      </Typography>
    </Paper>
  );
};

export default Privacy;
